<template>
  <div class="p-4">
    <div class="mb-base">
      <h4 class="mb-3">Manage API Keys</h4>
      <p>Your API Keys are one-way encrypted. We cannot display previously generated, original API keys.</p>
    </div>
    <div class="my-base-large">
      <div class="mb-base">
        <div class="mb-3">
        <vs-input
          v-validate="'required|min:3'"
          data-vv-validate-on="blur"
          :disabled="!isUserLoggedIn"
          name="Label"
          placeholder="Label your API Key"
          icon-no-border
          icon="icon icon-box"
          icon-pack="feather"
          v-model="apiKeyLabel"
          class="w-full lg:w-1/2"
        />
        </div>
        <vs-button
          class="invite-btn"
          :disabled="!apiKeyLabel"
          @click.stop="issueAPIKey()"
          >Generate API Key</vs-button
        >
      </div>
      <div v-if="Object.keys(generatedAPIKey).length" class="generated-api-key p-3">
        <div class="mb-3">
          <h5>Access Key Id</h5>
          <p>{{ generatedAPIKey.accessKeyId }}</p>
        </div>
        <div>
          <h5>API Key</h5>
          <p>{{ generatedAPIKey.apiKey }}</p>
        </div>
      </div>
    </div>
    <div>
      <vs-table :data="apiKeys">
        <template slot="thead">
          <vs-th> Label </vs-th>
          <vs-th> Access Key Id </vs-th>
          <vs-th> Creation Date </vs-th>
          <vs-th> Revoke </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].email">
              {{ data[indextr].label }}
            </vs-td>

            <vs-td v-if="data[indextr].accessKeyId">
              {{ data[indextr].accessKeyId }}
            </vs-td>
            <vs-td v-else>
            </vs-td>

            <vs-td v-if="data[indextr].createdAt">
              {{ data[indextr].createdAt.split('T')[0] }}
            </vs-td>
            <vs-td v-else>
            </vs-td>

            <vs-td>
              <vs-button color="danger" size="small" @click.stop="revokeAPIKey(data[indextr]._id, indextr)"
                >Revoke</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      apiKeyLabel: null,
      apiKeys: [],
      generatedAPIKey: {}
    };
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    }
  },
  watch: {
    orgData(newVal) {
      if(newVal) {
        this.$store.dispatch('organization/fetchAllAPIKeys', {
          organizationId: newVal._id
        }).then(res => {
          this.apiKeys = res;
        });
      }
    }
  },
  methods: {
    issueAPIKey() {
      if(!this.orgData || !this.userData || !this.apiKeyLabel) return;

      this.$vs.loading();

      const payload = {
        organizationId: this.orgData._id,
        label: this.apiKeyLabel,
        userId: this.userData._id
      };

      this.$store
        .dispatch("organization/issueAPIKey", payload)
        .then((res) => {
          this.generatedAPIKey = res;
          this.apiKeys.push(res);
          this.$vs.loading.close();
          this.$vs.notify({
            title: "New API Key Generated",
            color: "primary"
          });
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "API Key could not be generated",
            color: "danger"
          });
          throw err;
        });
      
      this.apiKeyLabel = null;
    },
    revokeAPIKey(apiKeyId, index) {
      if(!apiKeyId) return;

      this.$store.dispatch("organization/revokeAPIKey", { apiKeyId })
      .then(() => {
          this.apiKeys.splice(index, 1);
          this.$vs.loading.close();
          this.$vs.notify({
            title: "API Key revoked.",
            color: "primary"
          });
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Cannot revoke API Key",
            color: "danger"
          });
          throw err;
        });
    }
  },
  created() {
    if(this.orgData) {
      this.$store.dispatch('organization/fetchAllAPIKeys', {
        organizationId: this.orgData._id
      }).then(res => {
        this.apiKeys = res;
      });
    }
  }
};
</script>

<style scoped>
.my-base-large {
  margin: 3rem auto 4rem auto;
}

.invite-btn {
  border-radius: 4px;
}

.vs-con-table >>> .vs-table--not-data {
  display: none!important;
}

.generated-api-key {
  border: 1px solid #DFE3EB;
  border-radius: 4px;
}
</style>